import PropTypes from "prop-types";
import { setActiveLayout } from "../../helpers/product";
import { useTranslation } from "react-i18next";

const ShopTopAction = ({
  getLayout,
  setSort,
  getFilterSortParams,
  productCount,
  sortedProductCount,
}) => {
  const { t } = useTranslation();

  return (
    <div className="shop-top-bar mb-2">
      <div className="shop-tab d-md-block d-none">
        <button
          onClick={(e) => {
            getLayout("grid three-column");
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-th" />
        </button>
        <button
          onClick={(e) => {
            getLayout("list");
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-list-ul" />
        </button>
      </div>
      <div className="select-shoing-wrap align-items-center">
        <div className="shop-select mx-3">
          <select
            style={{ cursor: "pointer" }}
            onChange={(e) => setSort(e.target.value)}
          >
            <option style={{ cursor: "pointer" }} value="default">
              {t("default")}
            </option>
            <option style={{ cursor: "pointer" }} value="priceHighToLow">
              {t("price_high_to_low")}
            </option>
            <option style={{ cursor: "pointer" }} value="priceLowToHigh">
              {t("price_low_to_high")}
            </option>
            <option style={{ cursor: "pointer" }} value="dateNewToOld">
              {t("date_high_to_low")}{" "}
            </option>
            <option style={{ cursor: "pointer" }} value="dateOldToNew">
              {t("date_low_to_high")}{" "}
            </option>
          </select>
        </div>
      </div>
    </div>
  );
};

ShopTopAction.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
};

export default ShopTopAction;
